import React, { useEffect } from 'react'
import { Container, Row, Col, Card, CardBody, Table } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RankProps } from './RankProps'
import {
  locationEvent,
  pageInfo,
  pageViewEvent,
} from '../../Helpers/tagManager'

import { getUserSelector } from '../../Redux/selectors/auth'
// import LockIcon from 'mdi-react/LockIcon'
// import LockOpen from 'mdi-react/LockOpenIcon'

const Ranks: React.FunctionComponent<RankProps> = ({
  ranks,
  curator: { rank: curatorRank },
}) => {
  const { t } = useTranslation()

  const user = useSelector(getUserSelector)

  useEffect(() => {
    if (user) {
      pageViewEvent(user, pageInfo.rank)
      locationEvent()
    }
  }, [user])

  return (
    <Container className="balance-wrapper">
      <Col>
        <Row>
          <Col md={12}>
            <h3 className="page-title">{t('rankPage.pageTitle')}</h3>
          </Col>
        </Row>
      </Col>
      <Col lg={12} md={12} xl={12}>
        <Card>
          <CardBody>
            <Table className="table--bordered table-ranks" responsive>
              <thead>
                <tr>
                  {/* <th>{t('rankPage.status')}</th> */}
                  <th>{t('rankPage.description')}</th>
                  <th>{t('rankPage.score')}</th>
                  <th>{t('rankPage.reward')}</th>
                </tr>
              </thead>
              <tbody>
                {ranks.map(({ rank, score_required, reward_per_review }) => (
                  <tr
                    // @ts-ignore
                    className={curatorRank >= rank ? 'unlocked' : null}
                    key={rank}
                  >
                    {/* <td>{curatorRank >= rank ? <LockOpen /> : <LockIcon />}</td> */}
                    <td>
                      {t('rankPage.level')} {rank} <br />
                      <h4 className="subhead">Minimum fee per review</h4>
                    </td>
                    <td>{(+score_required).toLocaleString()}</td>
                    <td>${reward_per_review}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    </Container>
  )
}

export default Ranks
